export function setRoleData(data) {
    return {
        type: "SET_ROLE_DATA",
        payload: data
    }
}
